/** Testi del modulo Presenze: contatore, dichiarazione in sala, viste dell'amministratore. */
export const presenze = {
  contatore: {
    etichetta: 'Presenza',
    segnaposto: 'Presenza: il conteggio parte con la diretta.',
    soglia: (pct: number) => `Il test si apre con almeno il ${pct}% di presenza.`,
    inSalaDa: (ora: string) => `In sala dalle ${ora}`,
  },
  caduta: 'La connessione è caduta: i minuti già seguiti restano validi.',
  erroreHeartbeat: 'Non riusciamo ad aggiornare la presenza: i minuti già seguiti restano validi, riproviamo tra poco.',
  sala: {
    titolo: 'Sei in sala?',
    testo: 'Registra l’ingresso: i minuti in sala contano come quelli online. Quando esci, registra l’uscita.',
    testoOnline: 'Se segui dalla sala e non dal video, registra qui l’ingresso.',
    entra: 'Sono in sala',
    esci: 'Esco dalla sala',
    esciTitolo: 'Registrare l’uscita dalla sala?',
    esciTesto: 'I minuti seguiti finora restano validi. Se rientri, premi di nuovo "Sono in sala".',
    esciConferma: 'Sì, esco',
    resto: 'Resto in sala',
    dentroDa: (ora: string) => `In sala dalle ${ora}`,
    entrato: 'Ingresso registrato: i minuti in sala contano da adesso.',
    uscito: 'Uscita registrata. I minuti seguiti restano validi.',
    giaInSala: 'Risulti già in sala: non serve registrare di nuovo l’ingresso.',
    nonInSala: 'Non risulti in sala: registra prima l’ingresso.',
    fuoriFinestra: 'Puoi registrare l’ingresso da un’ora prima dell’inizio fino alla chiusura della diretta.',
    ancheOnline: 'Hai dichiarato la presenza in sala: il video resta disponibile ma i minuti non si sommano.',
    salaSenzaVideo: 'Segui lo schermo della sala. Qui trovi le slide e puoi fare domande al relatore.',
  },
  admin: {
    scheda: 'Presenze',
    titolo: 'Presenze',
    sottotitolo: 'Collegati online e dichiarati in sala, minuti e soglia. I dati si aggiornano ogni 10 secondi.',
    riepilogo: {
      collegatiOra: 'Collegati ora',
      inSalaOra: 'In sala ora',
      sopraSoglia: 'Sopra la soglia',
      totaleConfermati: 'Confermati',
      incoerenze: 'Incoerenze',
      incoerenzeAiuto: 'Dichiarati in sala e collegati online insieme: i minuti si uniscono, ma vale la pena controllare.',
    },
    schede: { inSala: 'In sala adesso', iscritti: 'Tutti gli iscritti' },
    inSala: {
      colonne: { nome: 'Nome', da: 'In sala dalle', dispositivo: 'Dispositivo', stato: 'Stato' },
      ancheOnline: 'Anche online',
      registraUscita: 'Registra l’uscita',
      nessuno: 'Nessuno ha ancora registrato l’ingresso in sala.',
      didascalia: 'Partecipanti dichiarati in sala',
    },
    iscritti: {
      colonne: { nome: 'Nome', modalita: 'Conferma', online: 'Online', sala: 'Sala', totale: 'Totale', percentuale: 'Presenza', ora: 'Adesso', dettagli: 'Ingressi e uscite' },
      nessuno: 'Nessun iscritto confermato per questo webinar.',
      nessunRisultato: 'Nessun iscritto corrisponde alla ricerca.',
      cerca: 'Cerca per nome o email',
      sopra: 'Sopra soglia',
      sotto: 'Sotto soglia',
      collegato: 'Collegato',
      inSala: 'In sala',
      incoerenza: 'In sala e online',
      assente: 'Assente',
      apriDettagli: 'Ingressi e uscite',
      didascalia: 'Presenze degli iscritti',
      modalita: { online: 'Online', sala: 'In sala' } as const,
      nonConfermato: 'Non confermato',
    },
    intervalli: {
      titolo: (nome: string) => `Ingressi e uscite di ${nome}`,
      testo: 'Ogni riga è un ingresso con la sua uscita. Le correzioni restano nel registro con il motivo.',
      colonne: { canale: 'Canale', inizio: 'Ingresso', fine: 'Uscita', origine: 'Origine', nota: 'Nota' },
      ancoraDentro: 'ancora dentro',
      annullato: 'annullato',
      nessuno: 'Nessun ingresso registrato.',
      canali: { online: 'Online', sala: 'Sala' } as const,
      origini: { heartbeat: 'Automatico (online)', dichiarazione: 'Dichiarato (sala)', manuale: 'Manuale', chiusura_automatica: 'Chiusura automatica' } as const,
      chiudi: 'Chiudi',
      annulla: 'Annulla',
      chiudiTitolo: 'Registrare l’uscita?',
      annullaTitolo: 'Annullare questo intervallo?',
      annullaTesto: 'L’intervallo non conterà più nei minuti. Resta visibile, barrato, con il motivo.',
      fine: 'Orario di uscita',
      fineAiuto: 'Lascia vuoto per usare l’orario attuale.',
      nota: 'Motivo',
      notaAiuto: 'Finisce nel registro eventi. Per esempio: "Uscito senza registrarsi, verificato dallo staff".',
      conferma: 'Conferma',
      chiuso: 'Uscita registrata.',
      annullatoOk: 'Intervallo annullato.',
      aggiungi: 'Aggiungi un intervallo manuale',
      aggiungiTesto: 'Per chi ha seguito senza che il sistema lo registrasse. Serve il motivo.',
      canale: 'Canale',
      inizio: 'Ingresso',
      fineManuale: 'Uscita',
      aggiunto: 'Intervallo aggiunto.',
      salva: 'Salva l’intervallo',
    },
    ricalcola: 'Ricalcola le presenze',
    ricalcolato: 'Presenze ricalcolate.',
    ricalcolaAiuto: 'Dopo una correzione manuale a diretta chiusa, ricalcola per aggiornare riepilogo e test.',
    vaiPresenze: 'Apri le presenze della diretta',
  },
};
